/**
 * Foundation Context · label ruoli lato client (visualizzazione).
 * Mappa dei display name di ruoli conosciuti. Non ha impatto su RBAC.
 */
export const ROLE_HIERARCHY_FE = {
  super_admin: "Super Admin (ROOT)",
  admin: "Amministratore",
  studio_operator: "Studio Operator",
  external_consultant: "Consulente Esterno",
  company_admin: "Amministratore Azienda",
  client: "Cliente",
  company_responsible: "Responsabile Azienda",
  responsabile: "Responsabile",
  employee: "Dipendente",
};
